export const openFullscreen = (): void => {
  const elem = document.documentElement;

  if (elem.requestFullscreen) {
    elem.requestFullscreen().then();
  } else if ('mozRequestFullScreen' in elem && typeof elem.mozRequestFullScreen === 'function') { // Firefox
    elem.mozRequestFullScreen();
  } else if ('webkitRequestFullscreen' in elem && typeof elem.webkitRequestFullscreen === 'function') { // Chrome, Safari, Edge
    elem.webkitRequestFullscreen();
  } else if ('msRequestFullscreen' in elem && typeof elem.msRequestFullscreen === 'function') { // IE/Edge
    elem.msRequestFullscreen();
  }
};

export const closeFullscreen = (): void => {
  if (document.fullscreenElement) {
    const elem = document;

    if (elem.exitFullscreen) {
      elem.exitFullscreen().then();
    } else if ('mozCancelFullScreen' in elem && typeof elem.mozCancelFullScreen === 'function') { // Firefox
      elem.mozCancelFullScreen();
    } else if ('webkitExitFullscreen' in elem && typeof elem.webkitExitFullscreen === 'function') { // Chrome, Safari, Edge
      elem.webkitExitFullscreen();
    } else if ('msExitFullscreen' in elem && typeof elem.msExitFullscreen === 'function') { // IE/Edge
      elem.msExitFullscreen();
    }
  }
};
